import React, { useEffect, useState } from 'react';
import withTable, { TableContext } from '../hoc/withTable';
import Table from '../components/Table';
import { InputDropdownCourse, InputTypeText } from '../elements';
import { Form } from 'informed';
import { fetchCourse } from '../services/options_service';
import {
  fetchPendingContracts,
  signDocument,
} from '../services/personal_data_service';

const PendingContractsPage = ({ ...props }) => {
  const [courses, setCourses] = useState();
  const getOptions = async () => {
    if (!courses) {
      const res = await fetchCourse();
      setCourses(res);
    }
  };

  useEffect(() => {
    getOptions();
  }, []);

  const onSignDocument = (e) => {
    // send the contract token
    signDocument(e.value).then((res) =>
      window.open(res, '_blank', 'noreferrer')
    );
  };

  const columns = [
    {
      Header: 'Assinar',
      accessor: 'contract',
      Cell: (d) => (
        <button onClick={() => onSignDocument(d)} className="btn btn-primary">
          Assinar
        </button>
      ),
      width: 120,
    },
    { Header: 'Aluno', accessor: 'real_name', width: 200 },
    { Header: 'CPF', accessor: 'cpf', width: 150 },
    { Header: 'E-mail', accessor: 'email', width: 200 },
    {
      Header: 'Status da assinatura',
      accessor: 'enrollment.contract_status.name',
      width: 250,
    },
    {
      Header: 'Processo de Matricula',
      accessor: 'enrollment.onboarding.name',
      width: 200,
    },
    {
      Header: 'Curso',
      accessor: 'enrollment.onboarding.course.name',
      width: 100,
    },
    { Header: 'Etapa', accessor: 'enrollment.onboarding.semester', width: 80 },
    { Header: 'Matricula', accessor: 'enrollment.token', width: 100 },
  ];
  return (
    <div className="list-base list-base-width" style={{ height: '100vh' }}>
      <div className="d-flex align-items-center position-relative">
        <h2 style={{ fontSize: '1.35rem' }}>Assinatura de contratos</h2>
      </div>
      <div className="d-flex flex-columns w-100" />
      <h2 style={{ fontSize: '1rem' }}>Filtros:</h2>

      <Form onValueChange={props.onFilterChange}>
        <div className="row">
          <InputDropdownCourse col="6" />
          <InputTypeText field="real_name" label="Nome do aluno" col="6" />
        </div>
      </Form>


      <TableContext.Consumer>
        {(props) => <Table {...props} manual={true} columns={columns} />}
      </TableContext.Consumer>
    </div>
  );
};
export default withTable(fetchPendingContracts)(PendingContractsPage);
